import { JsonSchema, JsonSchema7 } from '@jsonforms/core';
import traverse from 'json-schema-traverse';

const SCHEMA_KEYWORDS = ['properties', 'items', 'oneOf'];
const isNotSchemaWord = (word: string) => !SCHEMA_KEYWORDS.includes(word);
const isNotStringifiedNumber = (word: string) => isNaN(+word);

// This function extracts all required paths from a schema
export function extractRequiredPaths(schema: JsonSchema7 | JsonSchema): {
  requiredPaths: string[];
  oneOfPaths: string[];
  oneOfOptionsPaths: string[];
} {
  const requiredPaths: Set<string> = new Set();
  const oneOfPaths: Set<string> = new Set();
  const oneOfOptionsPaths: Set<string> = new Set();

  function addPath(set: Set<string>, path: string[]) {
    set.add(path.filter(isNotSchemaWord).filter(isNotStringifiedNumber).join('.'));
  }

  traverse(schema, {}, (schemaNode, jsonPointer) => {
    const pathArray = jsonPointer.split('/').filter(Boolean);

    if (schemaNode?.required) {
      schemaNode.required.forEach((requiredKey: string) => {
        addPath(requiredPaths, [...pathArray, requiredKey]);
      });
    }

    if (schemaNode?.oneOf) {
      addPath(oneOfPaths, pathArray);
      schemaNode.oneOf.forEach((oneOfOption: JsonSchema7) => {
        addPath(oneOfOptionsPaths, [...pathArray, extractOneOfOptionName(oneOfOption)]);
      });
    }
  });

  const uniqueRequiredPaths = Array.from(requiredPaths);
  const uniqueOneOfPaths = Array.from(oneOfPaths);
  const uniqueOneOfOptionsPaths = Array.from(oneOfOptionsPaths);

  return {
    requiredPaths: uniqueRequiredPaths,
    oneOfPaths: uniqueOneOfPaths,
    oneOfOptionsPaths: uniqueOneOfOptionsPaths,
  };
}

export const extractOneOfOptionName = (oneOfOption: JsonSchema) => {
  if (typeof oneOfOption.properties !== 'object') {
    throw new Error('oneOf option does not have properties');
  }
  const optionPropertyNames = Object.keys(oneOfOption.properties);
  if (optionPropertyNames.length !== 1) {
    throw new Error('oneOf option has more than one property');
  }
  return optionPropertyNames[0];
};
